
































import { Vue, Component, Prop, Ref } from 'vue-property-decorator';

import CalendarLayout from './CalendarLayout.vue';
import CalendarView from './CalendarView.vue';

import { Slot, SlotType, CalendarType, SlotsClinicMap } from '@/components/calendar/types';

import { getTodayDate } from '@/utils/date';

import { ISOCalendarDate, ISODateRange, ISODateTimeRange } from '@/utils/date/types';
import { SlotsMap } from './types';
import { Maybe } from '@/types/common';

@Component({
    components: {
        CalendarLayout,
        CalendarView,
    },
})
export default class CalendarRequests extends Vue {
    @Prop({ default: () => ({}) }) slots!: SlotsMap;
    @Prop({ default: () => ({}) }) slotsClinic!: SlotsClinicMap;
    @Prop({ default: true }) showCalendar!: boolean;
    @Prop({ default: '' }) highlight!: Maybe<ISODateTimeRange>

    @Ref() readonly $calendar!: CalendarView;
    @Ref() readonly $controls!: CalendarLayout;

    date = getTodayDate();

    selectSlot(slot: Slot) {
        if (slot.type === SlotType.PatientChosen) {
            this.$emit('select:slot', slot);
            return;
        }

        if (slot.type === SlotType.Free) {
            this.$emit('select:slot', slot);
            return;
        }

        // remove slot selection
        this.$emit('select:slot', null);
    }

    loadSlots(range: ISODateRange) {
        this.$emit('slots:load', range)
    }

    isMonthView(type: CalendarType) {
        return type === CalendarType.Month;
    }

    goPreviousPage() {
        this.$calendar.goPreviousPage();
    }

    goNextPage() {
        this.$calendar.goNextPage();
    }

    public setDay(date: ISOCalendarDate) {
        this.date = date;

        this.$controls.setDayView();
    }
}
